import { Component } from "react";

export default class SimpleReferring extends Component {
  render() {
    const value = this.props.params.value;
    return <div>{value}</div>;
  }
}
